import {
  Input,
  Popover,
  PopoverHandler,
  PopoverContent,
} from "@material-tailwind/react";
import { addMonths, addYears, format } from "date-fns";
import { Button, DayPicker } from "react-day-picker";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";

export type SelectDateProps = {
  label: string;
  setDate: (date: Date) => void;
  date: Date | undefined;
  className?: string;
};

export default function SelectDate({
  selectDateProps,
}: {
  selectDateProps: SelectDateProps;
}) {
  function handlePrevYear() {
    console.log(selectDateProps.date!);

    const newDate = addYears(selectDateProps.date!, -1);
    console.log(newDate);

    selectDateProps.setDate(newDate);
  }

  function handleNextYear(): void {
    const newDate = addYears(selectDateProps.date!, 1);
    selectDateProps.setDate(newDate);
  }

  function handlePrevMonth(): void {
    const newDate = addMonths(selectDateProps.date!, -1);
    selectDateProps.setDate(newDate);
  }

  function handleNextMonth(): void {
    const newDate = addMonths(selectDateProps.date!, 1);
    selectDateProps.setDate(newDate);
  }

  return (
    <div
      className={`m-2 md:w-1/2 w-full bg-white border-none ${selectDateProps.className}`}
    >
      <Popover placement="bottom">
        <PopoverHandler>
          <Input
            readOnly
            label={selectDateProps.label}
            value={
              selectDateProps.date ? format(selectDateProps.date, "PPP") : ""
            }
            crossOrigin={undefined}
          />
        </PopoverHandler>
        <PopoverContent placeholder={undefined} >
          <div className="flex justify-between mb-4">
            <button
              className="nav_button nav_button_previous"
              onClick={() => handlePrevYear()}
            >
              Prev Year
            </button>

            <button
              className="nav_button nav_button_next"
              onClick={() => handleNextYear()}
            >
              Next Year
            </button>
          </div>
          <DayPicker
            mode="single"
            month={selectDateProps.date}
            selected={selectDateProps.date}
            onDayClick={selectDateProps.setDate}
            showOutsideDays
            className="border-0"
            classNames={{
              caption: "flex justify-center py-2 mb-4 relative items-center",
              caption_label: "text-sm font-medium text-gray-900",
              nav: "flex items-center",
              nav_button:
                "h-6 w-6 bg-transparent hover:bg-blue-gray-50 p-1 rounded-md transition-colors duration-300",
              nav_button_previous: "absolute left-1.5",
              nav_button_next: "absolute right-1.5",
              table: "w-full border-collapse",
              head_row: "flex font-medium text-gray-900",
              head_cell: "m-0.5 w-9 font-normal text-sm",
              row: "flex w-full mt-2",
              cell: "text-gray-600 rounded-md h-9 w-9 text-center text-sm p-0 m-0.5 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-gray-900/20 [&:has([aria-selected].day-outside)]:text-white [&:has([aria-selected])]:bg-gray-900/50 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
              day: "h-9 w-9 p-0 font-normal",
              day_range_end: "day-range-end",
              day_selected:
                "rounded-md bg-gray-900 text-white hover:bg-gray-900 hover:text-white focus:bg-gray-900 focus:text-white",
              day_today: "rounded-md bg-gray-200 text-gray-900",
              day_outside:
                "day-outside text-gray-500 opacity-50 aria-selected:bg-gray-500 aria-selected:text-gray-900 aria-selected:bg-opacity-10",
              day_disabled: "text-gray-500 opacity-50",
              day_hidden: "invisible",
            }}
            components={{
              IconLeft: () => (
                <Button onClick={() => handlePrevMonth()}>
                  <IoChevronBackOutline size={17} />
                </Button>
              ),
              IconRight: () => (
                <Button onClick={() => handleNextMonth()}>
                  <IoChevronForwardOutline size={17} />
                </Button>
              ),
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
